/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col, Button } from 'react-bootstrap';

import {
  TextField,
} from 'ui/FormElement';

import deleteIcon from 'images/icons/invite/delete.svg';

function DescriptionGroupItems({
  parentName, collection, helpers, isReadonly,
}) {
  const { remove, push } = helpers;

  return (
    <div className="mb10">
      {collection.map(
        (item, index) => (
          <Row key={index}>
            <Col md={10}>
              <TextField
                name={`${parentName}.${index}.name`}
                placeholder="Item Title"
                disabled={isReadonly}
              />
            </Col>
            {!isReadonly && (
              <Col md={2} className="text-right">
                <Button bsStyle="link" onClick={() => remove(index)}>
                  <img src={deleteIcon} alt="delete" />
                </Button>
              </Col>
            )}
          </Row>
        ),
      )}
      {!isReadonly && (
        <Button
          onClick={() => push({
            name: '',
          })}
          bsStyle="primary"
        >
          Add Item
        </Button>
      )}
    </div>
  );
}

export default DescriptionGroupItems;

DescriptionGroupItems.propTypes = {
  parentName: PropTypes.string.isRequired,
  helpers: PropTypes.object.isRequired,
  collection: PropTypes.arrayOf(PropTypes.object),
  isReadonly: PropTypes.bool,
};

DescriptionGroupItems.defaultProps = {
  collection: [],
  isReadonly: false,
};
